import React from 'react';
import { useDispatch } from 'react-redux';
import { CloseButton } from '../../shared/svg/components';
import LoadConfigurationCodeService from '../../services/LoadConfigurationCodeService';
import { setPopupState } from '../../model/configuratorSlice';
import { PopupState } from '../../model/constants';
import { TranslationUtility } from '../../utilities/TranslationUtility';

const LoadConfigPopup = () => {
  const loadConfigurationCodeMutation = LoadConfigurationCodeService();
  const dispatch = useDispatch();
  const code = '';

  const loadConfiguration = () => {
    const copyText = document.getElementById('input-code');
    loadConfigurationCodeMutation.mutate(copyText.value.toUpperCase());
  };

  const isLoadConfigPopupOpened = true;

  return (
    <div className={`load-config-popup ${isLoadConfigPopupOpened ? ' opened' : ''}`}>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        className={`background ${isLoadConfigPopupOpened ? 'opened' : ''}`}
        type="button"
        onClick={() => dispatch(setPopupState(PopupState.None))}
      />
      <div className={`background${isLoadConfigPopupOpened ? ' opened' : ''}`} />
      <div className={`panel${isLoadConfigPopupOpened ? ' opened' : ''}`}>
        <div className="header">
          {TranslationUtility.GetFormattedMessageForUI('ui-load-panel-title', 'Cargar configuración')}
        </div>
        <div className="sub-header">
          {TranslationUtility.GetFormattedMessageForUI('ui-load-panel-subtitle',
              'Introduce el código de configuración:')}
        </div>
        <form className="form">
          <input
            className="input"
            name="code"
            type="text"
            id="input-code"
            placeholder="      "
            defaultValue={code}
          />
        </form>
        <div className="container-buttons">
          <button
            className="load-button"
            type="button"
            onClick={() => loadConfiguration()}
          >
            {TranslationUtility.GetFormattedMessageForUI('ui-load-panel-button', 'Cargar')}
          </button>
        </div>
        <button
          type="button"
          className="close-button"
          onClick={() => dispatch(setPopupState(PopupState.None))}
        >
          <CloseButton />
        </button>
      </div>
    </div>
  );
};

export default LoadConfigPopup;
